<template>
    <div v-if="external_links.length > 0">
        
            <b-button size="lg" :variant="item.class" block :href="item.url" target="_blank" v-for="item in external_links" :key="item.id">
                {{ item.name }}
            </b-button>        
        
    </div>    
</template>

<script>
import axios from "axios";

export default {
    name: 'componentExternalLinks',
    data: function() {
        return {
            external_links: [
            ]
        }

    },
    methods: {
        async refreshData() {
            var s = this
            await axios.get(
                this.$store.state.ws_url + "/portal/links?companyId=" + this.$store.state.config.companyId
            ).then(function(resp) {
                s.external_links = resp.data.obj;
            }).catch(function(error) {
                console.log(error)
            })
        }
    },
    mounted: function() {
        this.refreshData();
    }
    
}
</script>
